import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseDeleteUnusedTagsMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function useDeleteUnusedTagsMutation({
	onSuccess,
	onError,
	impersonationContext,
}: UseDeleteUnusedTagsMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tag/deleteUnused',
				}),
				'POST'
			);
		},
		onSuccess,
		onError,
	});
}
